import { DrEntity } from "./dr-entity";
import { DrObject, DrObjectType, SupportedRegExType } from './dr-object';

export class MediaIDViewModel extends DrObject {
    model: Partial<MediaID>;
    constructor(value?: Partial<MediaID>) {
        super(DrObjectType.MEDIAID, SupportedRegExType.METADATAVIEW);
        if (value) {
            this.model = value;
        }
    }
}
export class MediaID extends DrEntity {
    name: string;
    description: string;
    documentCount: number;
    dateCreated: string;
    archived: boolean;
    emailAddresses: Array<string>;
    handle: string;
    priority: number;
    userIds: Array<string>;

    // off-model display values
    iconClass: string;
    iconColor: string;

    constructor(value?: Partial<MediaID>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }

        this.iconClass = 'fa-laptop';
        this.iconColor = this.name === 'Unassigned' ? 'color-grey-08' : 'color-blue-01';

    }
}